// Copyright (c) 2025 by Audere

import { LabelTaskKey } from "../../utils/taskUtils";
import { LabelingRole, LabelingStatus } from "./labelApiSlice";

export enum LabelingEvent {
  AddLabels = "addLabels",
  ViewLabels = "viewLabels",
  openMessageFormAccordion = "openMessageFormAccordion",
  closeMessageFormAccordion = "closeMessageFormAccordion",
  ClearForm = "clearForm",
  MoveNextStep = "moveNextStep",
  MoveBackStep = "moveBackStep",
  StepClick = "stepClick",
  SubmitLabels = "submitLabels",
  UnsubmitLabels = "unsubmitLabels",
  SubmitReview = "submitReview",
  UnsubmitReview = "unsubmitReview",
  CloseTasks = "closeTasks",
  StartQC = "startQC",
  ReviewQC = "reviewQC",
  MarkCorrect = "markCorrect",
  MakeCorrection = "makeCorrection",
  RemoveCorrection = "removeCorrection",
}

export interface LogEventData {
  event: LabelingEvent;
  data: LogEventDetails;
}

export interface LogEventDetails {
  userEmail: string;
  conversationUid: string;
  userRole: LabelingRole;
  userGroup: string;
  labelType?: string;
  taskID?: LabelTaskKey;
  messageUid?: string;
  submitStatus?: LabelingStatus;
}
